import Vue from 'vue';
console.log(Vue, 6666666);
const DATARULE = {
  name: [{
    required: true,
    message: '请输入产品名称',
    trigger: 'blur'
  }, {
    min: 5,
    message: '至少输入5个字符',
    trigger: 'blur'
  }, {
    max: 50,
    message: '最多输入50字符',
    trigger: 'blur'
  }],
  unitId: [{
    required: true,
    message: '请选择承保单位',
    trigger: 'change'
  }],
  agencyId: [{
    required: true,
    message: '请选择承保机构',
    trigger: 'change'
  }],
  recordNumber: [{
    required: false,
    max: 50,
    message: '最多输入50字符',
    trigger: 'blur'
  }],
  recordName: [{
    required: false,
    max: 50,
    message: '最多输入50字符',
    trigger: 'blur'
  }],
  code: [{
    required: false,
    max: 30,
    message: '最多输入30字符',
    trigger: 'blur'
  }],
  description: [{
    required: false,
    max: 100,
    message: '最多输入100字符',
    trigger: 'blur'
  }]
};
const TERMRULE = {
  name: [{
    required: true,
    message: '请输入产品名称',
    trigger: 'blur'
  }, {
    min: 5,
    message: '至少输入5个字符',
    trigger: 'blur'
  }, {
    max: 100,
    message: '最多输入100字符',
    trigger: 'blur'
  }],
  linkName: [{
    required: true,
    message: '请上传条款文件',
    trigger: 'change'
  }],
  content: [{
    required: true,
    message: '请输入文本内容',
    trigger: 'change'
  }]
};
const TERMRULE2 = {
  name: [{
    required: true,
    message: '请输入产品名称',
    trigger: 'blur'
  }, {
    min: 4,
    message: '至少输入4个字符',
    trigger: 'blur'
  }, {
    max: 50,
    message: '最多输入50字符',
    trigger: 'blur'
  }],
  linkName: [{
    required: true,
    message: '请上传条款文件',
    trigger: 'change'
  }],
  content: [{
    required: true,
    message: '请输入文本内容',
    trigger: 'change'
  }]
};
const COLUMNSLIST = [{
  slots: {
    title: '文件名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '条款文件'
  },
  dataIndex: 'linkName',
  key: 'linkName',
  align: 'center',
  scopedSlots: {
    customRender: 'linkName'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 160,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const COLUMNSPLANLIST = [{
  slots: {
    title: '方案编码'
  },
  dataIndex: 'mark',
  key: 'mark',
  align: 'center'
}, {
  slots: {
    title: '方案名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  },
  customRender: (text, record) => {
    if (!text) {
      return '—';
    }
    return text;
  }
}, {
  slots: {
    title: '方案代码'
  },
  dataIndex: 'code',
  key: 'code',
  align: 'center',
  scopedSlots: {
    customRender: 'code'
  },
  customRender: (text, record) => {
    if (!text) {
      return '—';
    }
    return text;
  }
}, {
  slots: {
    title: '保障金额'
  },
  dataIndex: 'amount',
  key: 'amount',
  align: 'center'
}, {
  slots: {
    title: '保障期限'
  },
  dataIndex: 'duration',
  key: 'duration',
  align: 'center'
}, {
  slots: {
    title: '保费'
  },
  dataIndex: 'price',
  key: 'price',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: '4',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  },
  width: 100
}, {
  slots: {
    title: '操作'
  },
  key: '7',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 220
}];
const TERMLIST = [{
  id: 1,
  name: '年(单值)'
}, {
  id: 2,
  name: '年(范围)'
}, {
  id: 3,
  name: '天(单值)'
}, {
  id: 4,
  name: '天(范围)'
}, {
  id: 5,
  name: '终身'
}];
const AGELIST = [{
  id: 1,
  name: '天'
}, {
  id: 2,
  name: '月'
}, {
  id: 3,
  name: '周岁'
}, {
  id: 4,
  name: 'N天到N岁'
}, {
  id: 5,
  name: 'N月到N岁'
}, {
  id: 6,
  name: 'N岁以上'
}, {
  id: 7,
  name: 'N天以上'
}, {
  id: 8,
  name: 'N月以上'
}];
const PAYMENDEADLINE = [{
  id: 1,
  name: '年'
}, {
  id: 2,
  name: '季'
}, {
  id: 3,
  name: '月'
}, {
  id: 4,
  name: '周'
}, {
  id: 5,
  name: '天'
}];
const SEXLIST = [{
  id: 0,
  name: '无限制'
}, {
  id: 1,
  name: '男'
}, {
  id: 2,
  name: '女'
}];
const SOCIALSECURITYIST = [{
  id: 0,
  name: '无限制'
}, {
  id: 1,
  name: '有'
}, {
  id: 2,
  name: '无'
}];
export { DATARULE, TERMRULE, TERMRULE2, COLUMNSLIST, COLUMNSPLANLIST, TERMLIST, AGELIST, PAYMENDEADLINE, SEXLIST, SOCIALSECURITYIST };